<script setup lang="ts">
import {PhArrowSquareOut} from "@phosphor-icons/vue";
import {isLinkTypeAsset, type LinkTypes} from "#magnolia-layer/types/api";
import type {Component} from "#magnolia-layer/types/magnolia-types";

const props = defineProps<{
  metadata?: Component;
  title: string;
  link: LinkTypes;
}>();

const resolvedName = resolveName(props, props.metadata);
const resolvedItem = resolveLink(props);
</script>
<template>
  <div class="inner-content-grid article-margin-sm">
    <NuxtLink
      class="button group w-fit"
      :external="isLinkTypeAsset(link)"
      :target="resolvedItem.target"
      :to="resolvedItem.link">
      <div class="flex gap-px">
        <div class="bg-black p-2.5">
          <SvgoPrismDots
            class="w-7 h-7"
            :fontControlled="false"></SvgoPrismDots>
        </div>
        <div
          class="flex items-center gap-3 bg-black p-3 text-white group-hover:underline">
          <span class="font-sans">{{ resolvedName }}</span>
          <PhArrowSquareOut class="text-xl -mt-1"></PhArrowSquareOut>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
